/**
 * Frontend-Only Authentication Context
 * Simple authentication with hardcoded credentials stored in code
 * NO BACKEND AUTH REQUIRED
 */

import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

// Hardcoded admin credentials (CHANGE THESE HERE ONLY)
const ADMIN_USERNAME = 'siragupathippagam@gmail.com';
const ADMIN_PASSWORD = 'siraGu@#932';

/**
 * AuthProvider component
 * Manages admin authentication state purely on frontend
 */
export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check for existing session on mount
  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = () => {
    const storedAdmin = localStorage.getItem('admin');
    const storedToken = localStorage.getItem('authToken');

    if (storedAdmin && storedToken) {
      try {
        const adminData = JSON.parse(storedAdmin);
        setAdmin(adminData);
        setIsAuthenticated(true);
      } catch (error) {
        // Invalid stored data, clear it
        localStorage.removeItem('admin');
        localStorage.removeItem('authToken');
        setIsAuthenticated(false);
      }
    }

    setIsLoading(false);
  };

  const login = (username, password) => {
    return new Promise((resolve) => {
      // Simulate small delay for UX
      setTimeout(() => {
        // Check against hardcoded credentials
        if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
          const adminData = {
            id: 1,
            username: ADMIN_USERNAME,
          };

          // Store in localStorage
          localStorage.setItem('admin', JSON.stringify(adminData));
          localStorage.setItem('authToken', 'frontend-token-' + Date.now());

          setAdmin(adminData);
          setIsAuthenticated(true);

          resolve({ success: true });
        } else {
          resolve({
            success: false,
            error: 'Invalid username or password',
          });
        }
      }, 500);
    });
  };

  const logout = () => {
    // Clear localStorage
    localStorage.removeItem('admin');
    localStorage.removeItem('authToken');

    // Clear state
    setAdmin(null);
    setIsAuthenticated(false);
  };

  const value = {
    admin,
    isAuthenticated,
    isLoading,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

/**
 * Custom hook to use auth context
 */
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

